import { render, staticRenderFns } from "./ListingsSignPaperwork.vue?vue&type=template&id=07971cc6"
import script from "./ListingsSignPaperwork.vue?vue&type=script&lang=js"
export * from "./ListingsSignPaperwork.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../website-admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports